import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from './es'
import en from './en'
import de from './de'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'en',
  messages: {
    es,
    en,
    de
  }
})